import PropTypes from 'prop-types'
import { i18n } from 'core/i18n'

const { FormattedText } = i18n

export const DefaultValidationError = ({ errorTitle, errorDescription }) => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12">
                    <h4 className="accountCancelModal-title">
                        <FormattedText value={errorTitle} />
                    </h4>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <p className='accountCancelModal-description'>
                        <FormattedText value={errorDescription} />
                    </p>
                </div>
            </div>
        </div>
    )
}

DefaultValidationError.propTypes = {
    errorTitle: PropTypes.string.isRequired,
    errorDescription: PropTypes.string.isRequired,
}
